const optionGroup = window.ELEMENT.OptionGroup;
const render = optionGroup.render;
const data = optionGroup.data;

optionGroup.data = function (h) {
  let res = data.call(this);
  if (this.$parent.$options.componentName == 'ElOptionGroup') {
    res.level = this.$parent.level + 1;
  } else {
    res.level = 1;
  }
  return res;
};

optionGroup.render = function (h) {
  if (!this.isSelect) return render.call(this, h);
  return this.renderBox(h);
};

Object.assign(optionGroup.props, {
  // 是否可选的
  isSelect: {
    type: Boolean,
    default: false
  },
  value: {
    type: null
  }
});

Object.assign(optionGroup.methods, {
  renderBox(h) {
    let style = {
      'padding-left': this.level * 20 + 'px'
    };
    return (<ul class="el-select-group__box">
      <el-option label={this.label} value={this.value} disabled={this.disabled} style={style}>
        <i class="el-icon-caret-bottom"></i>
        {this.$slots.label || []}
      </el-option>
      <li>
        <ul class="el-select-group">{ this.$slots.default || [] }</ul>
      </li>
    </ul>);
  }
});